// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isWishlistGridEmpty(_) {
    return true;
}
function normalizePrice(amount) {
    return amount / 100;
}
export function itemToCard(item) {
    const amount = item.price?.amount || 0;
    return {
        name: item.nameLocalized || item.name,
        prices: item.price
            ? [
                {
                    amount: normalizePrice(amount),
                    currencyCode: item.price.currencyCode,
                    discount: item.discountedPrice
                        ? {
                            discountValue: normalizePrice(amount - item.discountedPrice.amount),
                            discountedPrice: normalizePrice(item.discountedPrice.amount),
                        }
                        : undefined,
                },
            ]
            : [],
        images: [
            {
                url: item.imageUrl,
            },
        ],
        embargoExternal: 0,
        cardUrl: item.pathName,
    };
}
export const replacePlaceholders = (label, itemsCount) => label.replace(/{count}/g, itemsCount).replace('{current}', '1');
